<template>
  <div id="footer-bar" class="xs-hide hide-print z3">
    <div id="footer-bar-items" class="max-width flex caps center fs-s reset-line-height">
      <router-link class="hover-red" v-if="showResources" to="resources" replace append>Media & Resources</router-link>
    </div>
  </div>
</template>

<script>
export default {

  name: 'FooterBar',

  data () {
    return {

    }
  },
  props: ['showResources']
}
</script>

<style lang="css" scoped>
  #footer-bar {
    width: 100vw;
    position: fixed;
    bottom: 0;
    left: 0;
    background: var(--col-light);
  }

  #footer-bar-items {
    border-top: 1px solid var(--black);

    a {
      flex: 1;
      display: inline-block;
      padding: 1em;
    }

    ul {
      margin: 1em 0;
      li {
        display: inline-block;
      }
    }
  }
</style>
